export default {
  gtcEditInfo: {
    title: 'Edit Signal Info',
    fields: {
      nameLabel: 'Signal Name',
      namePlaceholder: 'Please enter signal name',
      descLabel: 'Signal Description',
      descPlaceholder: 'Please enter signal description',
      photoLabel: 'Signal Photo',
    },
    actions: {
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    validation: {
      enterName: 'Please enter signal name',
      enterDesc: 'Please enter signal description',
      selectPhoto: 'Please select a signal photo',
    },
    notify: {
      successTitle: 'Success',
      successDesc: 'Signal info edited successfully',
      failTitle: 'Failed',
      failDesc: 'Failed to edit signal info',
    },
  },
  gtcArchive: {
    title: 'Archive Signal',
    info: 'This operation cannot be undone',
    agree: 'I have acknowledged and agree',
    actions: {
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    steps: {
      prepare: {
        title: 'Signal preparation',
        description: 'There are open positions. Please close all orders first.',
      },
      submit: {
        title: 'Submit request',
        description: 'Confirm and understand the result of archiving the signal',
      },
      next: {
        title: 'What happens next?',
        details: [
          'For new investors: This signal will no longer be investable',
          'For current investors: All active investments will be closed. The signal will be view-only.',
          'For you: All active investments will be closed. Performance fees will be paid at the end of the settlement period.',
          'This signal will be view-only',
        ],
      },
    },
    notifySuccess: 'Signal archived successfully',
    notifyFailed: 'Archive failed',
  },
  gtcPublishCard: {
    investable: 'Investable',
    notInvestable: 'Not investable',
    checkRequirements: 'Please check requirements',
    minDepositAmount: 'Minimum deposit amount',
    signalEquity: 'Signal net worth',
    totalEquity: 'Total net worth',
    tradesProgressFormat: 'Trades {current}/{min}',
    minClosedTradesTip: 'At least {min} closed trades',
    signalLifetime: 'Signal lifetime',
    sinceFirstOpenExceeded: 'Exceeded since first position opened: {duration}',
    lastTradePrefix: 'Last trade {duration}',
    lastTradeTip: 'Last trading activity must be within {duration} (including weekends)',
    shownInSquare: 'Shown in signal square',
    notShownInSquare: 'Not shown in signal square',
    archiveTime: 'Archive time',
    buttons: {
      deposit: 'Deposit',
      trade: 'Trade',
      report: 'Report',
      share: 'Share',
      editInfo: 'Edit Signal Info',
      archiveSignal: 'Archive Signal',
    },
    stats: {
      signalPrincipal: 'Signal principal',
      signalProfit: 'Signal profit',
      followerFunds: 'Follower funds',
      followerProfit: 'Follower profit',
      myShare: 'My performance fee',
      shareRatio: 'Performance fee rate',
      followerCount: 'Followers',
      followerCountTip: 'Current / Total',
      minCopyAmount: 'Minimum copy amount',
    },
    time: {
      year: 'year',
      month: 'month',
      day: 'day',
      hour: 'hour',
      minute: 'minute',
      second: 'second',
    },
    idLabelFormat: 'ID {id}',
  },
  gtcAssetsCard: {
    investTime: 'Investment time',
    submitTime: 'Submit time',
    stopTime: 'Stop time',
    labels: {
      investmentId: 'Investment ID',
      investmentAmount: 'Investment amount',
      profitLoss: 'Profit/Loss',
      performanceFee: 'Performance fee',
    },
  },
  gtcFastFunds: {
    fastDeposit: 'Fast Deposit',
    withdraw: 'Withdraw',
    transfer: 'Transfer',
  },
}